import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";


const useTools = () => {
    const tools = [<ReloadRecordsButton key='reload'/>];
    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Report Types')}
            tools={useTools()}
        />
    );
};
